import React, { useEffect, useState } from 'react';
import Wave from './Wave';

const WaveEffect = () => {
  let gradientId = 0;
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setReducedMotion(
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }
  }, []);

  return reducedMotion ? null : (
    <div className="wave-effect">
      <div className={'left-bottom'}>
        <Wave
          amplitude={50}
          frequency={0.002}
          speed={1.9}
          transform="translateY(75%) translateX(-20%) rotate(16deg)"
          color1={'#A4A4A4'}
          color2={'#DFDFDF'}
          strokeWidth={'30%'}
          gradientId={gradientId++}
        />
        <Wave
          amplitude={55}
          frequency={0.003}
          speed={2.045}
          transform="translateY(80%) translateX(-20%) rotate(16deg)"
          color1={'#D7D7D7'}
          color2={'#9D9D9D'}
          strokeWidth={'25%'}
          gradientId={gradientId++}
          reverseDirection={true}
        />
        <Wave
          amplitude={40}
          frequency={0.003}
          speed={1.6}
          transform="translateY(90%) translateX(-20%) rotate(16deg)"
          color1={'#828282'}
          color2={'#D4D4D4'}
          strokeWidth={'30%'}
          gradientId={gradientId++}
          reverseDirection={true}
        />
        <Wave
          amplitude={12}
          frequency={0.003}
          speed={3.5}
          transform="translateY(70%) translateX(-20%) rotate(16deg)"
          color1={'#FFFFFF'}
          color2={'#FFFFFF'}
          strokeWidth={'0.75%'}
          gradientId={gradientId++}
          reverseDirection={true}
        />
      </div>

      <div className={'right-top'}>
        <Wave
          amplitude={50}
          frequency={0.002}
          speed={1.9}
          transform="translateX(70%) translateY(20%) rotate(196deg)"
          color1={'#A4A4A4'}
          color2={'#DFDFDF'}
          strokeWidth={'30%'}
          gradientId={gradientId++}
        />
        <Wave
          amplitude={55}
          frequency={0.003}
          speed={2.045}
          transform="translateX(70%) translateY(15%) rotate(196deg)"
          color1={'#D7D7D7'}
          color2={'#9D9D9D'}
          strokeWidth={'25%'}
          gradientId={gradientId++}
          reverseDirection={true}
        />
        <Wave
          amplitude={40}
          frequency={0.003}
          speed={1.5}
          transform="translateX(70%) translateY(10%) rotate(196deg)"
          color1={'#828282'}
          color2={'#D4D4D4'}
          strokeWidth={'30%'}
          gradientId={gradientId++}
          reverseDirection={true}
        />
        <Wave
          amplitude={12}
          frequency={0.003}
          speed={3.5}
          transform="translateX(70%) translateY(25%) rotate(196deg)"
          color1={'#FFFFFF'}
          color2={'#FFFFFF'}
          strokeWidth={'0.75%'}
          gradientId={gradientId++}
          reverseDirection={true}
        />
      </div>
    </div>
  );
};

export default WaveEffect;
